// extracted by mini-css-extract-plugin
module.exports = {"cultivo-tr":"cards_cultivo-tr__a9HUL","trabajador-actividad-list":"cards_trabajador-actividad-list__2D6MG"};